import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../CookieAuth/auth.service';
import { Et } from '../interfaces/et';
import { ConfHttpService } from './conf-http.service';

@Injectable({
  providedIn: 'root'
})
export class EtService {
  endpopint:string='';
  et?:Et[];
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService) {
    this.endpopint=conf.getBackend();

   }
   get()
   {
   return this.http.get<Et[]>(this.endpopint+'et');
   }
   getPendientes()
  {
  return  this.http.get<Et[]>(this.endpopint+'etPendientes');
  }
  postNuevaEt(et:Et){
    et.token= this.cookie.getCookie();
    let id= this.http.post<number>(this.endpopint+'et',et ,{headers: this.headers}).toPromise().then(data =>{
      return data;

      });
      return id
  }
  getById(id:number){
    return  this.http.get<Et>(this.endpopint+'etGetById/'+ id);
  }
  putEt(et:Et){
    et.token= this.cookie.getCookie();
    return this.http.put<Et>(this.endpopint+'etupd/'+ et.id, et,{headers: this.headers}).toPromise();
  }
  cambioEstado(et:Et){
    et.token= this.cookie.getCookie();
    return this.http.post<Et>(this.endpopint+'etestado/'+ et.id, et,{headers: this.headers}).toPromise();

  }

}
